{
  "version": 1,
  "asset_id": "2275d88c-50d9-4f05-8241-d3d718ee7071",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/2275d88c-50d9-4f05-8241-d3d718ee7071/hiatal-type-4-es-v3-800.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/2275d88c-50d9-4f05-8241-d3d718ee7071/hiatal-type-4-es-v3-800.jpg",
  "original_filename": "hiatal-type-4-es-v3-800.jpg",
  "size": 131517,
  "content_type": "image/jpeg",
  "created_at": "2026-10-28T23:03:43Z"
}
